import * as types from '../mutation-types'
import Http from 'utils/http'

export const authorize = ({ dispatch }, token) => {
	return Http.headers(token ? { Authorization: `Bearer ${token}` } : {}).get('user').then(response => {
		dispatch(types.SET_AUTHORIZED, response.body.data);

		return response;
	});
}

export const authenticateWithWinecloud = ({ dispatch }, username, password) => {
	return Http.post('auth/winecloud', { username, password });
}

export const authenticateLocally = ({ dispatch }, username, password) => {
	return Http.post('auth/local', { username, password });
}

export const store = ({ dispatch }, username, password, guid) => {
	return Http.post('users', { username, password, guid });
}

export const register = ({ dispatch }, name, email, username, password, siteName) => {
	return Http.post('auth/register', { name, email, username, password, siteName });
}



// WEBPACK FOOTER //
// ./src/vuex/actions/user.js